<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header :disabledSearch="false"></Header>
            <div class="content">
                <div class="container pos-relative">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Mapping MARS</h2>
                            </div>
                            <div class="col-auto">
                                <div class="d-flex">
                                    <b-button-group class="h-75 mr-4" >
                                        <b-dropdown variant="outline-primary" right text="Download Template">
                                            <b-dropdown-item @click="_downloadTemplate('toko')">Toko</b-dropdown-item>
                                            <b-dropdown-item @click="_downloadTemplate('barang')">Barang</b-dropdown-item>
                                            <b-dropdown-item @click="_downloadTemplate('salesman')">Salesman</b-dropdown-item>
                                            <b-dropdown-item @click="_downloadTemplate('salesman')">TypeSalesman</b-dropdown-item>
                                        </b-dropdown>
                                    </b-button-group>
                                    <div class="alert alert-info">
                                    <b> <i class="fe fe-info mr-1"></i> SYARAT UPLOAD!</b> <br />
                                    Format file harus .xlsx atau .xls
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-body" v-if="dataMappingCheck.length <= 0">
                        <div class="frame-upload" @dragover.prevent @drop.prevent="_drop">
                            <div 
                                class="input-file"
                                :class="condition.isSubmit ? 'active' : ''"
                                >

                                <transition name="slide-fade-y" >
                                    <div v-if="file.data != null">
                                        <div class="img">
                                            <span v-html="file.size"></span>
                                            <span v-html="file.size"></span>
                                            <img :src="asset('excel.png')" alt="icon-excel" />
                                        </div>
                                        <p v-html="file.name" class="mt-2"></p>
                                    </div>
                                </transition>

                                <div v-if="!condition.isChosed">
                                    <div class="mb-3"> <i class="fa fa-clone" style="margin-bottom: -10px;"></i> </div>
                                    <div style="letter-spacing: 1px">PILIH TYPE MAPPING</div>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary" style="width: 200px; margin: 2px;"
                                        @click="condition.isChosed = true; file.type='Toko'">TOKO</button>
                                    </span><br>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary" style="width: 200px; margin: 2px;"
                                        @click="condition.isChosed = true; file.type='Barang'">BARANG</button>
                                    </span><br>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary" style="width: 200px; margin: 2px;" 
                                        @click="condition.isChosed = true; file.type='Salesman'">SALESMAN</button>
                                    </span><br>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary" style="width: 200px; margin: 2px;" 
                                        @click="condition.isChosed = true; file.type='TypeSalesman'">TYPESALESMAN</button>
                                    </span><br>
                                </div>

                                <div 
                                    v-if="condition.isChosed"
                                    @click="condition.isSubmit || !condition.isChosed ? false : $refs.file.click()">
                                    <input
                                        type="file"
                                        class="d-none"
                                        accept=".xlsx,.xls"
                                        ref="file"
                                        @change="_onFile"/>
                                    
                                    <div v-if="file.data == null && !condition.hasUploaded">
                                        <div class="mb-3"><i class="fe fe-upload"></i></div>
                                        <div style="letter-spacing: 2px">
                                            UPLOAD FILE EXCEL <br/>
                                            ATAU DRAG & DROP DISINI
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <transition name="slide-fade-y">
                            <div class="btn-fly" v-if="file.data != null">
                                <h3 
                                    v-if="condition.isSubmit"
                                    class="text-center"
                                    v-html="form.time >= 60 ? parseInt(form.time / 60) + ' menit ' + (form.time - 60 * parseInt(form.time / 60)) + ' detik' : form.time + ' detik'"
                                    >
                                </h3>
                                <button 
                                    @click="_importListToko"
                                    :disabled="condition.isSubmit"    
                                    class="btn btn-primary btn-pill"
                                    v-html="condition.isSubmit ? spin()+' Mohon menunggu...' : 'IMPORT'">
                                </button>
                            </div>
                        </transition>
                    </div>

                    <transition name="slide-fade-y">
                        <Skeleton
                            v-if="this.form.loading"
                            type="table"
                            :length="10"
                            class="mt-3 bg-white"
                        />
                        <section class="page-body" v-if="dataMappingCheck.length > 0 && !form.loading">
                            <div class="card" >
                                <div class="table-responsive overflow-auto" style="max-height: 680px;">
                                    <table class="table table-vcenter table-hover card-table table-striped table-control">
                                        <thead>
                                            <tr class="text-muted">
                                                <td class="pl-4">No</td>
                                                <td class="pl-4 text-capitalize" :key="index" v-for="(header ,index) in tableHeader">{{header.replaceAll('_', ' ')}}</td>
                                                <td class="pl-4">Status</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(data ,index) in dataMappingCheck" :key="index">
                                                <td>{{ ++index  }}</td>
                                                <td :key="index" v-for="(header, index) in tableHeader">
                                                    <input 
                                                        type="text" 
                                                        class="form-control"
                                                        v-model="data.request[header]">
                                                </td>
                                                <td>
                                                    <span
                                                        class="badge w-100"
                                                        :class=" data.valid ? 'bg-success' : 'bg-danger'"
                                                        v-html="data.valid ? 'VALID' : 'TIDAK VALID'">
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </section>
                    </transition>
                    <transition name="slide-fade-y" >
                        <div v-if="dataMappingCheck.length > 0 && !form.loading" class="d-flex flex-row-reverse">
                            <button :disabled="form.isSubmit" @click="_mappingUpdate" class="btn btn-primary ml-2" :key="2">Update Data</button>
                            <button :disabled="form.isSubmit" @click="_mappingCheck" class="btn btn-outline-primary ml-2" :key="1">Check Data</button>
                        </div>
                    </transition>


                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="./mapping-mars.scss" scoped/>
<script>
    import helper from "@/assets/js/helper.js"; 
    import { mapState, mapActions  } from "vuex";

    export default {
        name: "MappingMars",
        mixins: [helper],
        data() {
            return {
                file: {
                    type: null,
                    name: null,
                    size: null,
                    data: null
                },
                condition:{
                    hasUploaded: false,
                    isSubmit: false,
                    isFinish: false,
                    isChosed: false
                },
                form:{
                    time: 0,
                    loading: false,
                    isSubmit: false,
                    timeFinish: 0,
                    interval: null,
                    allowed: ["xlsx", "xls"],
                },
                tableHeader: [],
                templateExcel:{
                    toko: {
                        no_acc: 'Wajib diisi',
                        cust_no: 'Wajib diisi',
                        tim: 'Wajib diisi',
                        kode_perusahaan: 'Wajib diisi',
                        nama_depo: 'Wajib diisi',
                        code: 'Wajib diisi, code mapping',
                    },
                    barang: {
                        kode_barang: 'Wajib diisi',
                        nama_brand: 'Wajib diisi',
                        code: 'Wajib diisi, code mapping',
                    },
                    salesman: {
                        sales_name: 'Wajib diisi',
                        nama_tim: 'Wajib diisi',
                        nama_depo: 'Wajib diisi',
                        code: 'Wajib diisi, code mapping',
                    },
                }
            }
        },
        computed: {
            ...mapState("external_mars",{
                dataMappingCheck: state => state.datas.mappingCheck
            })
        },
        methods: {
            ...mapActions("external_mars",['mappingCheck','mappingUpdate']),

            _drop(event){
                this._onFile(event, {files : event.dataTransfer.files})
            },
            _onFile(event, params){
                const file = params == null ? event.target.files[0] : params.files[0];
                if(this.form.allowed.indexOf(file.name.split(".").pop()) < 0){
                    this.toast("Format file tidak valid");
                    return;
                }

                if(typeof FileReader === "function"){
                    const reader = new FileReader();
                    setTimeout(
                        () => {
                            reader.onload = (event) => {
                                this.file.data = file;
                                this.file.name = file.name;
                                this.file.size = this.formatBytes(file.size);
                            };
                            this.condition.hasUploaded = true
                            reader.readAsDataURL(file);
                        },this.condition.hasUploaded ? 500 : 0
                    )
                } else {
                    this.toast("FileReader API not supported");
                }
            },
            async _importListToko(){
                this.condition.isSubmit = true
                let payload = new FormData()
                payload.append('file',this.file.data)
                payload.append('type',this.file.type)

                let self = this.form;
                self.time = 1;
                self.timeFinish = 1;

                this.interval = setInterval(function () {
                    self.time = self.time + 1;
                    self.timeFinish = self.timeFinish + 1;
                }, 1000);

                try {
                    this.tableHeader = await this.mappingCheck(payload)
                    console.log(this.tableHeader)
                    clearInterval(this.interval);
                    this.form.loading = false
                    this.condition.isSubmit = false;
                    this.file.data = null;
                    this.condition.hasUploaded = false;
                    this.condition.isFinish = true;
                    this.condition.isChosed = false
                } catch (error) {
                    console.log(error)
                    this.form.loading = false
                    this.condition.isSubmit = false;
                    this.file.data = null;
                    this.condition.isSubmit = false;
                    this.condition.isFinish = true;
                    this.condition.isChosed = false
                    clearInterval(this.interval);
                }
            },
            async _mappingCheck(){
                this.form.loading = true
                this.form.isSubmit = true
                try {
                    await this.mappingCheck({type: this.file.type ,data: this.dataMappingCheck})
                    this.form.loading = false
                    this.form.isSubmit = false
                } catch (error) {
                    this.form.loading = false
                    this.form.isSubmit = false
                    this.onError(error);
                }
            },
            _mappingUpdate(){
                try {
                    this.$swal.fire({
                        title: 'Peringatan',
                        text: "Hanya data dengan status valid saja yang akan terupdate.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, update it!'
                        }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.form.loading = true
                            this.form.isSubmit = true
                            this.condition.isChosed = false
                            await this.mappingCheck({type: this.file.type ,data: this.dataMappingCheck})
                            const response = await this.mappingUpdate(this.dataMappingCheck)
                            this.form.isSubmit = false
                            this.form.loading = false
                        }
                    })
                } catch (error) {
                    this.onError(error);
                }
            },
            _downloadTemplate(type){
                this.createExcel({
                    data: [this.templateExcel[type]],
                    filename: "template_"+type+"_mapping_MARS"
                });
            }
        }
    }
</script>


            

